import API from '@/api/ModelTemplate'
import MixinFactory from '@/store/mixin'
const Mixin = MixinFactory('ModelTemplate')
import { path } from 'ramda'

const state = {
  ...Mixin.state,
}

const mutations = {
  ...Mixin.mutations,
}

const actions = {
  fetch: Mixin.actions.fetch(API.get),
  mutate: Mixin.actions.mutate(API.mutate),
  remove: Mixin.actions.remove(API.delete),
}

const getters = {
  getDisabledField: state => field => {
    return path(['item', 'metadata', 'disabledFields', field], state)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
